<script setup>
const props = defineProps({
    className: {
        type: String,
        default: ''
    }
});
</script>

<template>
    <svg :class="`stroke-current ${className}`" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
        <g stroke-width="20" transform="matrix(.96363 0 0 .96448 -314.38 -1776.201)">
            <path
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m 378.44881,2112.557 c 1.56314,-7.5925 6.07211,-19.2223 11.90374,-32.4188 4.50898,-10.3041 9.79958,-21.5121 15.09011,-32.479 13.76749,-28.6828 27.53495,-55.7386 27.29445,-59.8362 -0.3605,-5.7245 -2.10418,-11.2682 -4.32859,-16.6914 -2.6453,-6.4477 -5.89179,-12.7747 -8.35673,-19.0416 -1.44285,-3.8565 -2.64525,-7.6527 -3.12621,-11.3887 -0.72141,-5.3027 -1.02201,-13.4375 2.28457,-18.3184 10.22038,-15.2453 28.79744,-3.254 40.88157,5.3629 11.78345,-8.4361 30.96175,-21.03 41.36244,-5.6642 3.30663,4.8809 3.00604,13.0157 2.28457,18.3184 -0.84166,6.3271 -3.30658,12.4131 -6.01197,18.4389 -1.74349,3.9168 -3.66731,7.7733 -5.29053,11.6901 -2.28457,5.5437 -4.14829,11.208 -4.50902,16.9927 -0.60122,9.1592 52.30434,87.133 55.97165,127.6264 -109.83907,33.1419 -66.7331,50.0744 -165.45005,-2.5911 z"
            ></path>
            <path
                fill="none"
                stroke-linecap="round"
                d="m 486.18376,1984.8704 c -5.4709,3.736 -8.47696,5.5437 -13.94785,6.7489"
            ></path>
            <path
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M431.89544 1912.4403c-.0601-.3615-1.68333-6.4476-4.32864-23.1993M494.54041 1913.4647c.18026-.7231 1.68336-6.4476 4.32861-23.1993"
            ></path>
            <path
                fill="none"
                stroke-linecap="round"
                d="m 434.11987,1984.8704 c 5.4709,3.736 8.47693,5.5437 13.94786,6.7489"
            ></path>
            <path
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M399.4307 1896.0501c18.27646-8.1348 41.30238-12.6541 66.07177-11.8708 20.68129.6628 39.73931 4.8809 55.55083 11.6298M448.54869 1857.1235c0-5.5438 4.6292-10.0631 10.28046-10.0631 5.71143 0 10.28055 4.5193 10.28055 10.0631 0 5.604-10.22041 4.4591-10.28055 10.1233l-.0601 16.5107"
            ></path>
        </g>
    </svg>
</template>
